import { render, staticRenderFns } from "./DrugRank.vue?vue&type=template&id=bfa51a90&scoped=true&"
import script from "./DrugRank.vue?vue&type=script&lang=js&"
export * from "./DrugRank.vue?vue&type=script&lang=js&"
import style0 from "./DrugRank.vue?vue&type=style&index=0&id=bfa51a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa51a90",
  null
  
)

export default component.exports